<template>
  <LoaderCar v-if="loading" width="600px" marginTop="0"/>
  <template v-else>
    <Toast />
    <HeaderHome :user="this.$store.state.user.prenom"/>
    <div class="background">

      <!-- Colonne gauche : liste -->
      <div class="panel panel-list">

        <div class="panel-header">
          <div class="panel-header-left">
            <div>
              <p class="panel-label">Gestion</p>
              <h2 class="panel-title">Stage de code</h2>
            </div>
          </div>
          <button class="btn-add" @click="openAddForm()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Nouveau stage
          </button>
        </div>

        <div class="filters-row">
          <button class="filter-pill" :class="{ active: checkJourneeaVenir }" @click="filtreJourneeaVenir">À venir</button>
          <button class="filter-pill" :class="{ active: checkJourneePasse }" @click="filtreJourneeaPasse">Passé</button>
        </div>

        <div class="table-wrap">
          <DataTable
            :value="this.journees"
            :rows="6"
            tableStyle="width:100%"
            v-model:selection="selectedItem"
            selectionMode="single"
            responsiveLayout="scroll"
            :rowsPerPageOptions="[6, 10, 20, 50]"
            :paginator="true"
            dataKey="id"
            @click="changeBackground"
          >
            <Column field="libelle" header="Libellé" :sortable="true"></Column>
            <Column header="Date" :sortable="true">
              <template #body="slotProps">
                <template v-if="slotProps.data.dateFin">Du {{ slotProps.data.date }} au {{ slotProps.data.dateFin }}</template>
                <template v-else>{{ slotProps.data.date }}</template>
              </template>
            </Column>
            <Column field="fullHoraire" header="Horaires" :sortable="true"></Column>
            <Column field="nbrPlace" header="Places dispo" :sortable="true"></Column>
          </DataTable>
        </div>
      </div>

      <!-- Colonne droite : formulaire -->
      <div class="panel panel-form">

        <template v-if="selectedItem == null && addForm == false">
          <div class="empty-state">
            <div class="empty-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5">
                <rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18M8 4V2M16 4V2"/>
              </svg>
            </div>
            <p class="empty-title">Aucune journée sélectionnée</p>
            <p class="empty-sub">Cliquez sur une journée dans la liste ou créez-en une nouvelle</p>
          </div>
        </template>

        <template v-else>
          <div class="form-header">
            <h2 class="form-title">
              <span v-if="selectedItem == null">Ajouter un stage</span>
              <span v-else>Modifier le stage</span>
            </h2>
            <p class="form-sub" v-if="selectedItem != null">{{ selectedItem.libelle }}</p>
          </div>

          <div class="form-body">

            <!-- AJOUT -->
            <template v-if="selectedItem == null">
              <div class="field-group">
                <label class="field-label">Libellé <span class="required">*</span></label>
                <input type="text" class="field-input" placeholder="Libellé du stage" v-model="this.form.libelle" />
              </div>
              <div class="field-group">
                <label class="field-label">Description</label>
                <textarea class="field-input" v-model="this.form.description"></textarea>
              </div>
              <div class="field-row">
                <div class="field-group">
                  <label class="field-label">Heure de début</label>
                  <input type="time" class="field-input" v-model="this.form.horaireDebut" />
                </div>
                <div class="field-group">
                  <label class="field-label">Heure de fin</label>
                  <input type="time" class="field-input" v-model="this.form.horaireFin" />
                </div>
              </div>
              <div class="field-row">
                <div class="field-group">
                  <label class="field-label">Date de début</label>
                  <input type="date" class="field-input" v-model="this.form.date" />
                </div>
                <div class="field-group">
                  <label class="field-label">Date de fin</label>
                  <input type="date" class="field-input" v-model="this.form.dateFin" />
                </div>
              </div>
              <div class="field-group">
                <label class="field-label">Nombre de places <span class="required">*</span></label>
                <input type="number" class="field-input" v-model="this.form.nbrPlace" />
              </div>

              <div class="form-actions">
                <button class="btn btn-primary" @click="postJourneeInfo">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                  Valider
                </button>
              </div>
            </template>

            <!-- EDITION -->
            <template v-else>
              <div class="field-group">
                <label class="field-label">Libellé <span class="required">*</span></label>
                <input type="text" class="field-input" v-model="this.selectedItem.libelle" />
              </div>
              <div class="field-group">
                <label class="field-label">Description</label>
                <textarea class="field-input" v-model="this.selectedItem.description"></textarea>
              </div>
              <div class="field-row">
                <div class="field-group">
                  <label class="field-label">Heure de début</label>
                  <input type="time" class="field-input" v-model="this.selectedItem.horaireDebut" />
                </div>
                <div class="field-group">
                  <label class="field-label">Heure de fin</label>
                  <input type="time" class="field-input" v-model="this.selectedItem.horaireFin" />
                </div>
              </div>
              <div class="field-row">
                <div class="field-group">
                  <label class="field-label">Date de début</label>
                  <input type="date" class="field-input" v-model="this.selectedItem.date" />
                </div>
                <div class="field-group">
                  <label class="field-label">Date de fin</label>
                  <input type="date" class="field-input" v-model="this.selectedItem.dateFin" />
                </div>
              </div>
              <div class="field-group">
                <label class="field-label">Nombre de places <span class="required">*</span></label>
                <input type="number" class="field-input" v-model="this.selectedItem.nbrPlace" />
              </div>

              <button class="btn-mail" @click="setMailEleveStage">
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="M3 7l9 6 9-6" stroke="currentColor" stroke-width="1.5"/></svg>
                Envoyer les mails aux élèves
              </button>

              <p class="section-title">Élèves inscrits</p>

              <div class="search-eleve">
                <SimpleTypeahead
                  id="typeahead_id"
                  :key="typeaheadKey"
                  placeholder="Rechercher un élève..."
                  :items="leleves"
                  :minInputLength="1"
                  :itemProjection="
                    (item) => {
                      return item.fullname;
                    }
                  "
                  @selectItem="selectItem"
                  @onInput="searchEleve"
                >
                </SimpleTypeahead>
                <button class="cancel-search" v-if="showCancelSearch" @click="cancelSearchEleve">
                  <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                </button>
              </div>

              <DataTable
                :value="this.selectedItem.journeeReservations"
                :rows="3"
                :paginator="true"
                :rowsPerPageOptions="[3, 10, 20, 50]"
                dataKey="id"
                v-model:selection="selectedJourneeReservation"
              >
                <Column field="eleve.nom" header="Nom"></Column>
                <Column field="eleve.prenom" header="Prénom"></Column>
                <Column field="nbrInscrits" header="Inscrits"></Column>
                <Column :exportable="false" style="width:3rem">
                  <template #body="slotProps">
                    <button class="btn-remove" @click="deleteJourneeReservation(slotProps.data.id)">
                      <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                    </button>
                  </template>
                </Column>
              </DataTable>

              <div class="form-actions">
                <button class="btn btn-primary" @click="putJournee">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                  Modifier
                </button>
                <button class="btn btn-danger" @click="deleteJournee">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>
                  Supprimer
                </button>
              </div>
            </template>

          </div>
        </template>
      </div>

    </div>

    <Dialog
      v-model:visible="showInscriptionDialog"
      modal
      header="Inscription au stage de code"
      :style="{ width: '450px', maxWidth: '95vw' }"
    >
      <div class="inscription-dialog">
        <p class="inscription-eleve">{{ eleveSelectionne ? eleveSelectionne.fullname : '' }}</p>
        <p class="inscription-journee" v-if="selectedItem">
          {{ selectedItem.libelle }} — {{ selectedItem.date }}
        </p>

        <div class="form-actions">
          <button class="btn btn-primary" @click="postJourneeReserv">
            S'inscrire
          </button>
        </div>
      </div>
    </Dialog>
  </template>
</template>

<script>
import { useToast } from "primevue/usetoast";
import HeaderHome from '../../components/home/HeaderHome.vue';
import LoaderCar from '../../components/LoaderCar.vue';
import SimpleTypeahead from "vue3-simple-typeahead";

export default {
    name: "StageCodeAgence",
    data() {
        return {
            toast: useToast(),
            loading: true,
            c: null,
            addForm: false,
            checkJourneeaVenir: false,
            checkJourneePasse: false,
            journees: [],
            selectedItem: null,
            form: {
                journeeInfoId: null,
                libelle: "",
                description: "",
                horaireDebut: "",
                horaireFin: "",
                date: "",
                dateFin: "",
                nbrPlace: null,
            },
            leleves: [],
            typeaheadKey: 0,
            showInscriptionDialog: false,
            eleveSelectionne: null,
            showCancelSearch: false,
            nbrInscritsForm: 1,
        };
    },
    mounted() {
        this.getJournees();
    },
    methods: {

      goToHome() {
        this.$router.push({ name: "Home" });
      },

      searchEleve(e){
        if(e.input.length == 3 || e.input.length == 6 || e.input.length == 9 || e.input.length == 12 || e.input.length == 15 || e.input.length == 18 || e.input.length == 21){
          window.api
          .get("/eleves/agence/planning/search/"+this.$store.state.user.agence.id+"/"+e.input, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.leleves = response.data.eleves;
          })
          .catch((error) => {
            console.log(error);
          });
        }
      },

      selectItem(e){
        this.eleveSelectionne = e;
        this.nbrInscritsForm = 1;
        this.showInscriptionDialog = true;
        this.showCancelSearch = true;
      },

      cancelSearchEleve(){
        this.eleveSelectionne = null;
        this.leleves = [];
        this.showCancelSearch = false;
        this.typeaheadKey++;
      },

      async postJourneeReserv() {
        if (this.selectedItem.nbrPlace - this.nbrInscritsForm < 0) {
          this.toast.add({
            severity: "error",
            summary: "Inscription impossible",
            detail: "Il n'y a pas assez de places pour cette journée",
            life: 3000,
          });
          return;
        }

        window.api
          .post(
            "/stagecode/" + this.selectedItem.id + "/reservation/" + this.eleveSelectionne.id,
            {},
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then(() => {
            this.showInscriptionDialog = false;
            this.eleveSelectionne = null;
            this.leleves = [];
            this.showCancelSearch = false;
            this.typeaheadKey++;
            this.getJournees();
            this.toast.add({
              severity: "success",
              summary: "Inscription réussie",
              detail: "L'élève a été inscrit avec succès",
              life: 3000,
            });
          })
          .catch((error) => {
            console.log("ERRR::", error.response.data);
            this.toast.add({
              severity: "error",
              summary: "Erreur",
              detail: "Une erreur est survenue lors de l'inscription",
              life: 3000,
            });
          });
      },

      setMailEleveStage(){

        this.selectedItem.journeeReservations.forEach(e => {
          window.api
          .get("/stage/code/mail/"+ e.eleve.id + "/" + this.selectedItem.id, {
            headers: {
                          Authorization: "Bearer " + this.$store.state.token,
                      },
          })
              .then(() => {

              })
              .catch((error) => {
                  console.log(error.response.data.message);
              });
        })


      },

          async getJournees() {
              try {
                  window.api
                      .get("/AllStageCode/" + this.$store.state.user.agence.id, {
                      headers: {
                          Authorization: "Bearer " + this.$store.state.token,
                      },
                  })
                      .then((response) => {
                      this.journees = response.data.journees;
                      this.loading = false;
                      if (this.selectedItem != null) {
                          this.selectedItem = this.journees.find((j) => j.id == this.selectedItem.id) || null;
                      }
                  });
              }
              catch (e) {
                  // handle authentication error here
              }
          },
          filtreJourneeaVenir() {
              if (this.checkJourneeaVenir == false) {
                  this.checkJourneeaVenir = true;
                  this.checkJourneePasse = false;
                  let todayDate = new Date().toLocaleString("en-US");
                  this.journees = this.journees.filter((jr) => new Date(jr.dateEn).getTime() >= new Date(todayDate).getTime());
              }
              else {
                  this.checkJourneeaVenir = false;
                  this.getJournees();
              }
          },
          filtreJourneeaPasse() {
              if (this.checkJourneePasse == false) {
                  this.checkJourneePasse = true;
                  this.checkJourneeaVenir = false;
                  let todayDate = new Date().toLocaleString("en-US");
                  this.journees = this.journees.filter((jr) => new Date(jr.dateEn).getTime() <= new Date(todayDate).getTime());
              }
              else {
                  this.checkJourneePasse = false;
                  this.getJournees();
              }
          },
          async putJournee() {
            try {
                window.api.put("/stage_codes/" + this.selectedItem.id, {
                    libelle: this.selectedItem.libelle,
                    description: this.selectedItem.description,
                    dateDebut: this.selectedItem.date,
                    dateFin: this.selectedItem.dateFin,
                    horaireDebut: this.selectedItem.horaireDebut,
                    horaireFin: this.selectedItem.horaireFin,
                    nbrPlace: this.selectedItem.nbrPlace,
                }, {
                    headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                    },
                }).then(() => {
                        this.toast.add({
                            severity: "success",
                            summary: "Stage de code changé",
                            detail: "L'etat de votre stage de code à été changé avec succès",
                            life: 3000,
                        });
                    });
            }
            catch (e) {
                // handle authentication error here
            }
          },
          async postJourneeInfo() {
            window.api
                .post("/stage_codes", {
                libelle: this.form.libelle,
                description: this.form.description,
                dateDebut: this.form.date,
                dateFin: this.form.dateFin,
                horaireDebut: this.form.horaireDebut,
                horaireFin: this.form.horaireFin,
                nbrPlace: this.form.nbrPlace,
                agence : "/api/agences/" + this.$store.state.user.agence.id,
            }, {
                headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                },
            })
                .then((response) => {
                this.form.journeeInfoId = response.data.id;
                this.$emit("completed", response.data);
                this.toast.add({
                    severity: "success",
                    summary: "Stage de code Ajouté",
                    detail: "Votre stage de code à été Ajouté avec succès",
                    life: 3000,
                });
                this.getJournees();
                this.addForm = false;
            })
                .catch((error) => {
                // handle authentication and validation errors here
                console.log("ERRR::", error.response.data);
            });
          },

          async deleteJournee() {
              if (confirm("Voulez vous vraiment supprimer ce stage de code?")) {
                  window.api
                      .delete("/stage_codes/" + this.selectedItem.id, {
                      headers: {
                          Authorization: "Bearer " + this.$store.state.token,
                      },
                  })
                      .then((response) => {
                      this.selectedItem = null;
                      this.getJournees();
                      this.$emit("completed", response.data);
                  })
                      .catch((error) => {
                      // handle authentication and validation errors here
                      console.log("ERRR::", error.response.data);
                  });
              }
          },

          changeBackground() {
              if (this.selectedItem != null) {
                  this.addForm = false;
              }
          },
          openAddForm() {
              this.selectedItem = null;
              this.addForm = true;
          },
          deleteJourneeReservation(id) {
              try {
                  if (confirm("Voulez vous vraiment supprimer cette Reservation ?")) {
                      window.api
                          .delete("stagecode/" + id, {
                          headers: {
                              Authorization: "Bearer " + this.$store.state.token,
                          },
                      })
                          .then(() => {
                          this.toast.add({
                              severity: "success",
                              summary: "Reservation Supprimé",
                              detail: "La Reservation à été Supprimé avec succès",
                              life: 3000,
                          });
                          this.getJournees();
                      });
                  }
              }
              catch (e) {
                  // handle authentication error here
              }
          },
      },
      components: { HeaderHome, LoaderCar, SimpleTypeahead }
};
</script>

<style scoped>

/* ── Layout principal ── */
div.background {
  min-height: 100vh;
  width: 100%;
  background: #f4f6f9;
  display: flex;
  gap: 20px;
  padding: 24px;
  box-sizing: border-box;
}

/* ── Panneaux ── */
.panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-list {
  flex: 1 1 60%;
  min-width: 0;
}

.panel-form {
  flex: 0 0 38%;
  max-width: 480px;
}

/* ── En-tête panneau liste ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid #e2e8f0;
  gap: 12px;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.panel-label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  text-align: left;
}

.panel-title {
  margin: 2px 0 0;
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  text-align: left;
}

/* ── Bouton "Nouveau stage" ── */
.btn-add {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  background: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s;
}

.btn-add:hover {
  background: #2563eb;
}

/* ── Filtres ── */
.filters-row {
  display: flex;
  gap: 10px;
  padding: 14px 22px 0;
}

.filter-pill {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s;
}

.filter-pill:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.filter-pill.active {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #3b82f6;
}

/* ── Tableau ── */
.table-wrap {
  padding: 16px;
  flex: 1;
  overflow: auto;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 14px;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  font-size: 13px;
  color: #334155;
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f0f7ff !important;
  cursor: pointer;
}

:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #eff6ff !important;
  color: #1d4ed8;
}

:deep(.p-paginator) {
  background: transparent;
  border: none;
  padding: 8px 0 4px;
  font-size: 13px;
}

/* ── État vide ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 48px 32px;
  text-align: center;
}

.empty-icon {
  width: 72px;
  height: 72px;
  background: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.empty-title {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
}

.empty-sub {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
  max-width: 240px;
  line-height: 1.5;
}

/* ── En-tête formulaire ── */
.form-header {
  padding: 20px 24px 0;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 16px;
}

.form-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.form-sub {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

/* ── Corps du formulaire ── */
.form-body {
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}

.field-row {
  display: flex;
  gap: 14px;
}

.field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.field-input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.18s, background 0.18s;
  appearance: auto;
  font-family: inherit;
}

.field-input:focus {
  border-color: #3b82f6;
  background: #ffffff;
}

textarea.field-input {
  min-height: 70px;
  resize: vertical;
}

/* ── Bouton mail ── */
button.btn-mail {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  background-color: #0ea5e9;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 9px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.18s;
}

button.btn-mail:hover {
  background-color: #0284c7;
}

p.section-title {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.search-eleve {
  position: relative;
}

:deep(#typeahead_id) {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 9px 12px;
  padding-right: 34px;
  width: 100%;
  font-size: 13px;
  box-sizing: border-box;
  background: #f8fafc;
}

button.cancel-search {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  background: #f1f5f9;
  color: #64748b;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 21;
}

button.cancel-search:hover {
  background: #e2e8f0;
}

.simple-typeahead :deep(.simple-typeahead-list) {
  position: absolute;
  z-index: 20;
  background-color: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 220px;
  overflow-y: auto;
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
  width: 100%;
}

.simple-typeahead :deep(.simple-typeahead-list-item) {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
}

.simple-typeahead :deep(.simple-typeahead-list-item:hover),
.simple-typeahead :deep(.simple-typeahead-list-item.simple-typeahead-list-item-active) {
  background-color: #f0f7ff;
}

button.btn-remove {
  background: #fee2e2;
  color: #dc2626;
  border: none;
  border-radius: 8px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.18s;
}

button.btn-remove:hover {
  background: #fecaca;
}

/* ── Actions ── */
.form-actions {
  display: flex;
  gap: 10px;
  padding-top: 4px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, opacity 0.18s;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-primary {
  background: #3b82f6;
  color: #ffffff;
}

.btn-primary:hover:not(:disabled) {
  background: #2563eb;
}

.btn-danger {
  background: #fee2e2;
  color: #dc2626;
}

.btn-danger:hover:not(:disabled) {
  background: #fecaca;
}

/* ── Dialog inscription ── */
.inscription-dialog {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.inscription-eleve {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.inscription-journee {
  margin: -12px 0 0;
  font-size: 13px;
  color: #64748b;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 900px) {
  div.background {
    flex-direction: column;
  }

  .panel-form {
    max-width: 100%;
  }
}
</style>
